module.exports = __webpack_public_path__ + "img/4.8920a81c.jpg";